import type { ReactNode } from 'react';
import type { AppConfig } from '../config';
import { MockAuthGate } from './MockAuthGate';
import { MsalAuthGate } from './MsalAuthGate';

export function AuthGate({ config, children }: { config: AppConfig; children: ReactNode }) {
  return config.authMode === 'msal' ? (
    <MsalAuthGate entra={config.entra}>{children}</MsalAuthGate>
  ) : (
    <MockAuthGate>{children}</MockAuthGate>
  );
}
